import { styled } from '@mui/material/styles'

import WSprites from '../../assets/images/sprites/wsprite.png'

// Prevent the custom prop `active` from leaking to the DOM
const shouldForwardActive = (prop: PropertyKey) => prop !== 'active'

interface FaqAccordionProps {
  active: boolean
}

export const FaqSectionsWrapper = styled('div')({
  marginTop: 30,
  '@media (max-width: 992px)': {
    marginTop: 5,
  },
})

export const FaqSectionWrapper = styled('div')(({ theme }) => ({
  borderRadius: 9,
  backgroundColor: '#ffffff',
  boxShadow: '0 4px 8px 2px rgba(0, 0, 0, 0.2)',
  margin: '0 0 20px',
}))

export const FaqSectionTitle = styled('h4', { shouldForwardProp: shouldForwardActive })<FaqAccordionProps>(
  ({ active }) => ({
    margin: '0 0 0px 0',
    fontFamily: "'SharpSansDisplayNo1-Medium', tahoma, helvetica, arial, sans-serif",
    fontSize: 16,
    fontWeight: 600,
    lineHeight: 1.5,
    cursor: 'pointer',
    padding: '15.5px 20px',
    display: 'block',
    textDecoration: 'none',
    color: '#131313',
    position: 'relative',
    '::after': {
      content: '""',
      display: 'inline-block',
      backgroundImage: `url(${WSprites})`,
      backgroundPosition: '-1448px -217px',
      width: 16,
      height: 11,
      transform: active ? 'rotate(180deg)' : 'rotate(0deg)',
      position: 'absolute',
      right: 25,
      top: '50%',
      marginTop: -5.5,
      transition: 'none',
    },
  })
)

export const FaqQuestionsWrapper = styled('div', { shouldForwardProp: shouldForwardActive })<FaqAccordionProps>(
  ({ active }) => ({
    padding: '0 20px 0px',
    overflow: 'hidden',
    transition: 'max-height 0.3s ease',
    ...(active && {
      borderTop: '1px solid #cfcecc',
    }),
  })
)

export const FaqQuestionWrapper = styled('div')(({ theme }) => ({
  borderBottom: '1px solid #cfcecc',
  paddingBottom: 10,
  '&:last-child': {
    borderBottom: 'none',
  },
}))

export const FaqQuestionTitle = styled('h5', { shouldForwardProp: shouldForwardActive })<FaqAccordionProps>(
  ({ active }) => ({
    cursor: 'pointer',
    textDecoration: 'none',
    fontFamily: "'OpenSans-Regular', sans-serif",
    fontSize: 14,
    fontWeight: 600,
    lineHeight: 1.71,
    color: '#131313',
    padding: '15.5px 0 15.5px 5px',
    marginBottom: 5,
    '::before': {
      content: '""',
      display: 'inline-block',
      backgroundImage: `url(${WSprites})`,
      backgroundPosition: active ? '-1448px -280px' : '-1451px -309px',
      height: active ? 9 : 14,
      width: 17,
      position: 'relative',
      top: -2,
      marginRight: 13,
    },
  })
)

export const FaqQuestionAnswer = styled('p', { shouldForwardProp: shouldForwardActive })<FaqAccordionProps>(
  ({ active }) => ({
    margin: '0 40px 0',
    fontFamily: "'OpenSans-Regular', sans-serif",
    fontSize: 14,
    lineHeight: 1.71,
    color: '#131313',
    overflow: 'hidden',
    transition: 'max-height 0.2s ease',
    a: {
      textDecoration: 'none',
      color: '#266dcc',
    },
    ...(active && {
      paddingBottom: 20,
    }),
  })
)
